<template>
  <component :is="layout" />
</template>

<script>
export default {
  computed: {
    layout() {
      return this.$route.meta.layout || "layout-default";
    }
  }
};
</script>
